import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const caption1StrongClassNames = {
  root: 'fui-Caption1Strong'
};
/**
 * Styles for the root slot
 */
export const useCaption1StrongStyles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "fwrc4pm"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}"]
});